export default {
    aggregateChart: {
        forecastFutures: 'forecast + futures',
        futuresOnly: 'futures only',
        finalPosition: 'Final position',
        netPositionAxis: 'Net position (MWh)  ·  + SHORT  /  − LONG',
        short: 'SHORT',
        long: 'LONG',
        flat: 'flat',
        hrForecast: 'HR · forecast',
        hrFutures: 'HR · futures',
        siForecast: 'SI · forecast',
        siFutures: 'SI · futures',
        ariaLabel: 'Cross-contract aggregate stacked chart, {country}',
        allCountries: 'all countries',
        noForecastNotePre: 'No forecast feed for this range — bands show',
        noForecastNoteRest:
            '(the forecast baseline is zero). Once a forecast run is ingested it will appear here.',
        signPre: 'Net position —',
        signAbove: 'above 0 = SHORT',
        signAboveDesc: '(under-procured, buy more) ·',
        signBelow: 'below 0 = LONG',
        signBelowDesc:
            '(over-procured, surplus to sell). A buy offsets demand, so it moves the line down.',
    },
}
